
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/price",
      function () {
        return require("private-next-pages/phone/price/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/price"])
      });
    }
  